import { ActionReducerMap } from '@ngrx/store';

import * as fromBooking from './booking.reducer';
import * as fromUi from './ui.reducer';
import { bookingReasonReducer, BookingReasonState } from '../booking-reason';

export interface State {
  ui: fromUi.UiState;
  booking: fromBooking.BookingState;
  bookingReason: BookingReasonState;
}

export const reducers: ActionReducerMap<State> = {
  ui: fromUi.uiReducer,
  booking: fromBooking.bookingReducer,
  bookingReason: bookingReasonReducer,
};
